import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

const DeleteAlertModal = ({
  delModeOpen,
  toggle,
  deleteTeamMember,
  deleteGroupView,
  deleteMemberView,
  groupName,
}) => {
  const _closeModal = () => {
    toggle();
  };
  const _removeUser = () => {
    if (deleteTeamMember) {
      deleteTeamMember();
    }
    if (deleteGroupView) {
      deleteGroupView();
    }
    if (deleteMemberView) {
      deleteMemberView();
    }

    _closeModal();
  };

  return (
    <Modal centered isOpen={delModeOpen} toggle={() => _closeModal()}>
      <ModalBody>
        <p className="fs-20 m-0">
          {deleteTeamMember
            ? "Are you sure that you want to delete this member ?"
            : deleteMemberView
              ? "Are you sure that you want to delete this member from this group ?"
              : deleteGroupView
                ? `Are you sure that you want to delete this Group? ${groupName}`
                : null}
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="link" className="closeBtn" onClick={() => _closeModal()}>
          No
        </Button>
        <Button color="primary" type="button" onClick={() => _removeUser()}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default DeleteAlertModal;
